export const messages = {
  en: {
    printOweFee: {
      paymentNotice: 'Payment Notice',
      owner: 'Owner',
      printTime: 'Print Time',
      chargeObject: 'Charge Object',
      itemName: 'Item Name',
      feePeriod: 'Fee Period',
      unit: 'Unit',
      areaUsage: 'Area/Usage',
      unitPrice: 'Unit Price',
      amount: 'Amount',
      amountInWords: 'Amount in Words',
      noData: 'No payment notice data available',
      scanToPay: 'Scan to Pay',
      scanTip: 'Please scan the QR code with WeChat to pay directly without login.',
      scanExpire: 'This QR code is valid for long term.',
      qrcodeGenerating: 'Generating QR code...'
    }
  },
  zh: {
    printOweFee: {
      paymentNotice: '缴费通知单',
      owner: '业主',
      printTime: '打印时间',
      chargeObject: '收费对象',
      itemName: '项目名称',
      feePeriod: '费用期间',
      unit: '单位',
      areaUsage: '面积/用量',
      unitPrice: '单价',
      amount: '金额',
      amountInWords: '大写人民币（元）',
      noData: '当前没有缴费通知数据',
      scanToPay: '微信扫码支付',
      scanTip: '业主使用微信扫描下方二维码,无需登录即可直接支付。',
      scanExpire: '本二维码长期有效。',
      qrcodeGenerating: '二维码生成中...'
    }
  },
  'zh-TW': {
    printOweFee: {
      paymentNotice: '繳費通知單',
      owner: '業主',
      printTime: '列印時間',
      chargeObject: '收費對象',
      itemName: '項目名稱',
      feePeriod: '費用期間',
      unit: '單位',
      areaUsage: '面積/用量',
      unitPrice: '單價',
      amount: '金額',
      amountInWords: '大寫人民幣（元）',
      noData: '目前沒有繳費通知資料',
      scanToPay: '微信掃碼支付',
      scanTip: '業主使用微信掃描下方二維碼,無需登錄即可直接支付。',
      scanExpire: '本二維碼長期有效。',
      qrcodeGenerating: '二維碼生成中...'
    }
  }
}
